import { render, staticRenderFns } from "./PatientMonitoring.vue?vue&type=template&id=0bb73f6e&scoped=true&"
import script from "./PatientMonitoring.vue?vue&type=script&lang=js&"
export * from "./PatientMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./PatientMonitoring.vue?vue&type=style&index=0&id=0bb73f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb73f6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VIcon,VProgressCircular,VRow,VSnackbar,VSpacer,VTextField})
